/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/return_1'
export default icon
